export default {
  title: {
    en: 'Having issues with your shipment?',
  },
  text: {
    en: 'Please tell us if something went wrong, and we’ll do our best to help:',
  },
  optionWait: {
    en: 'Wait for response, don’t cancel for now',
  },
  optionWaitFreeMonth: {
    en: 'Wait for response, don’t cancel, get next month for free',
  },
  optionCancel: {
    en: 'Send and cancel subscription',
  },
  buttonTitle: {
    en: 'Send',
  },
  label: {
    en: 'Message',
  },
}
